import { Injectable } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { CommandInput, CommandTemplate } from "../../../entities/commandTemplate/commandTemplate";
import { CommandService, Flow, HasCommands } from "../command.service";

@Injectable({
    providedIn: 'root'
  })
export class NoFlow implements Flow {

    dialogRef: DynamicDialogRef | undefined;

    constructor(
    ) { }

    executeFlow(commandService: CommandService, hasCommands: HasCommands,
      commandTemplate: CommandTemplate, commandInput: CommandInput,
      completionCallback: () => void) {

        // this flow does not do anything, just sends the command and then returns
        commandService.sendCommand(commandInput, () => {
          completionCallback();
        })
    }

  }
